import { useQueryParams } from "duck";
import { useGetOrganizationsQuery } from "requests";

export const useOrganizations = () => {
  const [{ search, filter, pagination }] = useQueryParams();
  const { data, loading, refetch } = useGetOrganizationsQuery({
    variables: {
      page: pagination?.page || 1,
      perPage: 15,
      filter: {
        ...(search && { like: { name: search } }),
        ...(filter?.status && {
          OR: [
            {
              equal: { status: filter?.status?.[0] || "" }
            },
            !!filter?.status?.[1] && {
              equal: { status: filter?.status?.[1] || "" }
            }
          ].filter(Boolean)
        })
      }
    },
    fetchPolicy: "cache-and-network"
  });

  const organizations = data?.organizations?.collection;

  return {
    organizations,
    totalCount: data?.organizations?.paginationInfo.totalCount || 0,
    refetch,
    loading
  };
};
